/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

(function ($, Drupal, once) {

  Drupal.behaviors.headerSearchBlock = {
    attach: function (context) {
      'use strict';

      var searchIcons = context.getElementsByClassName('search-icon');

      // Mobile Menu Show/Hide.
      for (var i = 0; i < searchIcons.length; i++) {
        $(once("search-icon", searchIcons[i])).click(function (e) {

          var searchBlockForm = this.nextElementSibling;
          this.classList.toggle('search-icon--open');
          searchBlockForm.classList.toggle('search-block-form--open');

          var searchInput = searchBlockForm.querySelector('input[type="search"]');
          searchInput.focus();
        });
      }
    }
  }

})(jQuery, Drupal, once);
